export default __webpack_public_path__ + "static/media/head-front.e1d2d0a2.png";